enum PaymentStatus {
  PENDING = 'PENDING',
  INVOICE_GENERATED = 'INVOICE_GENERATED',
  REPORT_GENERATED = 'REPORT_GENERATED',
  PAID = 'PAID',
}

export default PaymentStatus;
